import {fetchFluxBotAction} from "@/api/endpoints/fluxbot";


export async function checkWaitlistStatus({srcWallet}: {
	srcWallet: string;
}): Promise<any> {
	return await fetchFluxBotAction(srcWallet,"waitlist", {});
}
